var Backbone = require('backbone');
var _ = require('underscore');

require('./IndexLogin.less');


module.exports = Backbone.View.extend({

    el: '.IndexLogin',

    events: {
        'click .IndexLogin-button': 'onLoginClick',
        'input .IndexLogin-input': 'onLoginInputChange',
        'keydown .IndexLogin-input': 'onLoginInputKeyDown'
    },


    initialize: function () {
        _.bindAll(this, 'onLoginInputChange');
    },


    show: function () {
        this.$el.addClass('visible');

        this.$('.IndexLogin-input[name="email"]').focus();

        //check auto filled inputs by browser
        setTimeout(this.onLoginInputChange, 0);
        setTimeout(this.onLoginInputChange, 100);
        setTimeout(this.onLoginInputChange, 300);
        setTimeout(this.onLoginInputChange, 500);
        setTimeout(this.onLoginInputChange, 1000);
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    onLoginClick: function () {
        var $emailInput = this.$('.IndexLogin-input[name="email"]');
        var $passwordInput = this.$('.IndexLogin-input[name="password"]');
        var $button = this.$('.IndexLogin-button');

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();

        this._xhr = $.ajax(Urls['member:api:login']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'email': $emailInput.val(),
                'password': $passwordInput.val()
            }),
            'success': function (data) {
                this.trigger('login', data);
            }.bind(this),
            'error': function (data) {
                console.log(data);
                $button.flashClass('Button--shake', 500);
                $button.removeClass('Button--loading');
            }.bind(this)
        });
    },


    onLoginInputKeyDown: function (e) {
        var $emailInput = this.$('.IndexLogin-input[name="email"]');
        var $passwordInput = this.$('.IndexLogin-input[name="password"]');

        if (e.keyCode == 13) {
            if ($(e.currentTarget).is($emailInput)) {
                if ($emailInput.val() && $passwordInput.val()) {
                    this.onLoginClick();
                } else {
                    $passwordInput.focus();
                }
            }

            if ($(e.currentTarget).is($passwordInput)) {
                this.onLoginClick();
            }

            e.preventDefault();
        }
    },


    onLoginInputChange: function (e) {
        var $emailInput = this.$('.IndexLogin-input[name="email"]');
        var $passwordInput = this.$('.IndexLogin-input[name="password"]');
        var $button = this.$('.IndexLogin-button');
        var isValid = $emailInput.val() && $passwordInput.val();

        $button.toggleClass('IndexLogin-button--active', !!isValid);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/components/IndexLogin/IndexLogin.js
// module id = 17
// module chunks = 0